import { Component, Output, EventEmitter, inject, OnInit, OnChanges } from '@angular/core';
import { NursingAuditService } from "src/app/services/nursing-audit.service";

@Component({
    selector: 'app-resolution-code-select',
    templateUrl: './resolution-code-select.component.html',
    styleUrls: ['./resolution-code-select.component.scss'],
    standalone: false
})
export class ResolutionCodeSelectComponent implements OnInit, OnChanges {
  private auditService = inject(NursingAuditService);

  filter:any = {changeValue:true}
  resCodeOptions: any[] = [];
  @Output() resCodeselected = new EventEmitter<any>();
  ngOnInit(): void {
    this.loadResOptions();
  }

  ngOnChanges(): void {
    this.loadResOptions();
  }

  loadResOptions(){
    this.auditService.getresCodeSelect(this.filter).subscribe((res)=> {
      this.resCodeOptions = [{label: "All Resolutions", value: "All"}].concat(
        (res as any)["resCodeSelect"].map((resolution: any) =>{
          return {label: resolution.label, value: resolution.value}
        })    
      )
    this.filter.resCode = ["All"]
    })
  }

  changeResolutionCode(event: any){
    if (event.value.length == 0){
      this.filter.resCode = ["All"]
      }
      else if (event.value[event.value.length - 1] == 'All'){
        this.filter.resCode = ['All']
      }
      else{
        if (event.value.includes('All')){
          this.filter.resCode.splice(this.filter.resCode.indexOf('All'), 1)
        } 
      }
    // this.filter.resCode = event.value;
    this.resCodeselected.emit(this.filter);
  }
}
